import Marquee from "react-fast-marquee";
import { Star, Quote } from "lucide-react";
import { SectionHeader } from "@/components/Reveal";
import { TESTIMONIALS } from "@/lib/data";

const Card = ({ t }) => (
  <figure
    data-testid={`testimonial-card-${t.slug}`}
    className="w-[340px] sm:w-[400px] shrink-0 mx-3 rounded-2xl border border-slate-900/10 bg-white p-7 hover:border-sky-400/40 transition-colors duration-500"
  >
    <div className="flex items-center justify-between">
      <div className="flex gap-1">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star key={i} className="w-4 h-4 text-sky-600 fill-sky-400" />
        ))}
      </div>
      <Quote className="w-5 h-5 text-slate-600" />
    </div>
    <blockquote className="text-sm text-slate-600 leading-relaxed mt-5 min-h-[100px]">
      «&nbsp;{t.quote}&nbsp;»
    </blockquote>
    <figcaption className="mt-5 pt-5 border-t border-slate-900/10">
      <p className="font-display text-lg font-bold uppercase tracking-wide text-slate-900">{t.client}</p>
      <p className="text-xs text-slate-9000 mt-0.5">{t.business}</p>
      <span className="inline-block mt-3 rounded-full bg-sky-400/10 border border-sky-400/25 px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-sky-600">
        {t.equipment}
      </span>
    </figcaption>
  </figure>
);

const Testimonials = () => {
  const rowA = TESTIMONIALS.slice(0, 4);
  const rowB = TESTIMONIALS.slice(4);
  return (
    <section id="temoignages" data-testid="testimonials-section" className="relative py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          center
          caption="Témoignages"
          title="Des entrepreneurs d'ici, financés pour vrai"
          subtitle="Cliniques, transporteurs, excavateurs, déneigeurs : des centaines de PME québécoises nous font confiance pour équiper leur croissance."
        />
      </div>
      <div className="mt-14 space-y-6 [mask-image:linear-gradient(90deg,transparent,black_8%,black_92%,transparent)]">
        <Marquee speed={30} gradient={false} pauseOnHover>
          {rowA.map((t) => <Card key={t.slug} t={t} />)}
        </Marquee>
        <Marquee speed={30} gradient={false} pauseOnHover direction="right">
          {rowB.map((t) => <Card key={t.slug} t={t} />)}
        </Marquee>
      </div>
    </section>
  );
};

export default Testimonials;
